import { useState, type ReactElement } from 'react';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';
import { ApplicationList } from '@/components/application/applicationList';
import UnauthorizedAccess from "@/components/healths/UnauthorizedAccess.tsx";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Card, CardBody, CardHeader, ButtonGroup } from 'reactstrap';
import Onboarding from '@/components/documentation/obboarding';
import { Link } from 'react-router-dom';

export function Documentation(): ReactElement {

  const [itemToDisplay, setItemToDisplay] = useState(0);
  
  if (sgwtConnect.isAuthorized())
    {
      return (
      <div>
      <h2>Documentation</h2>
      <Row className='mt-3'>
          <Col lg="2" xl="3">
          <ul className="list-group">
            <li className="list-group-item">Onboard your WebApp
              <ul className="list-group">
              <li className="list-group-item" style={{ cursor: 'pointer' }} onClick={() => { setItemToDisplay(0); }}>Configure credential</li>
              <li className="list-group-item" style={{ cursor: 'pointer' }} onClick={() => { setItemToDisplay(1); }}>Configure your Web App</li>
              <li className="list-group-item" style={{ cursor: 'pointer' }} onClick={() => { setItemToDisplay(2); }}>Configure your Api Healthcheck</li>
              </ul>
            </li>
          </ul>
          </Col>
          <Col lg="10" xl="9" style={{ marginTop: "-18px" }}> 
            <Onboarding displayItem={itemToDisplay} />
         </Col>
      </Row>
  </div>
    );
  }
  return <UnauthorizedAccess />;
}